/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-unused-vars */
/* eslint-disable @typescript-eslint/naming-convention */
import React, { useState, useEffect, useMemo } from 'react';
import { message } from 'antd';
import { axiosErp } from 'shared/config/axios';
import { getStoredAuthToken } from 'shared/utils/authToken';
import { SaveOutlined } from '@ant-design/icons';
import { useFormContext, Controller } from 'react-hook-form';
import { useQueryClient } from 'react-query';
import formatCurrency from 'shared/utils/formatCurrency';
import { formatDateTime } from 'shared/utils/dateTime';

import { v4 as uuidv4 } from 'uuid';
import { TableCosting, InputNumberFormat } from 'shared/components';
import { StyledButton, StyledContainerButton, StyledFormItem } from './Styles';
import { FormValues } from './formValues.model';

type RevenueTableProps = {
  haierCostData: any;
};

const RevenueTable: React.FC<RevenueTableProps> = ({ haierCostData }) => {
  const { control, trigger } = useFormContext<FormValues>();
  const token = getStoredAuthToken();
  const queryClient = useQueryClient();

  const [priceCost, setpriceCost] = useState<any[]>([]);
  const [priceCostOnChange, setpriceCostOnChange] = useState<boolean>(false);
  const [priceCostOnBlur, setpriceCostOnBlur] = useState<boolean>(false);
  const [totalCostPrice, setTotalCostPrice] = useState<number[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const {
    _id,
    order,
    jobNumber,
    truckType,
    driver,
    licensePlate,
    tripNo,
    vendor,
    cost,
    revenue,
    grandTotal,
  } = haierCostData;

  const onChangePriceCost = (index, name, value) => {
    setpriceCostOnChange(true);
    setpriceCost((prevpriceCost) => {
      const updatedpriceCost = [...(prevpriceCost || [])];
      updatedpriceCost[index][name] = value;
      return updatedpriceCost;
    });
  };

  const columnsTableService = [
    {
      title: 'Order Info.',
      align: 'left',
      style: {
        padding: '6px',
        backgroundColor: '#F6F6F6',
        margin: '-6px',
      },
      children: [
        {
          title: 'Order No.',
          dataIndex: 'orderNo',
          key: 'orderNo',
          width: 130,
        },
        {
          title: 'Pickup Name',
          dataIndex: 'pickupName',
          key: 'pickupName',
          width: 100,
        },
        {
          title: 'Pickup Provinces',
          dataIndex: 'pickupProvince',
          key: 'pickupProvince',
          width: 130,
        },
        {
          title: 'Consignee Name',
          dataIndex: 'consigneeName',
          key: 'consigneeName',
          width: 130,
        },
        {
          title: 'Type',
          dataIndex: 'type',
          key: 'type',
          width: 80,
        },
        {
          title: 'Pricing Type',
          dataIndex: 'pricingType',
          key: 'pricingType',
          width: 120,
        },
        {
          title: 'Billing Month',
          dataIndex: 'billingMonth',
          key: 'billingMonth',
          width: 120,
        },
        {
          title: 'Delivery Province',
          dataIndex: 'deliveryProvince',
          key: 'deliveryProvince',
          width: 150,
        },
        {
          title: 'Delivery Zone',
          dataIndex: 'deliveryZone',
          key: 'deliveryZone',
          width: 120,
        },
        {
          title: 'Material Description',
          dataIndex: 'itemName',
          key: 'itemName',
          width: 300,
        },
        {
          title: 'Order CBM',
          dataIndex: 'cbm',
          key: 'cbm',
          width: 100,
        },
        {
          title: 'Order QTY',
          dataIndex: 'quantity',
          key: 'quantity',
          width: 100,
        },
        {
          title: 'Lift Qty',
          dataIndex: 'liftQuantity',
          key: 'liftQuantity',
          width: 100,
        },
        {
          title: 'Unpack Qty',
          dataIndex: 'unpackQuantity',
          key: 'unpackQuantity',
          width: 100,
        },
        {
          title: 'Other Service Qty',
          dataIndex: 'otherServiceQuantity',
          key: 'otherServiceQuantity',
          width: 130,
        },
        {
          title: 'RT Qty',
          dataIndex: 'rtQuantity',
          key: 'rtQuantity',
          width: 100,
        },
        {
          title: 'RT Name',
          dataIndex: 'rtName',
          key: 'rtName',
          width: 100,
        },
      ],
    },
    {
      title: 'Trip & Job Info.',
      align: 'left',
      style: {
        padding: '6px',
        backgroundColor: '#F6F6F6',
        margin: '-6px',
      },
      children: [
        {
          title: 'Trip No',
          dataIndex: 'tripNo',
          key: 'tripNo',
          width: 120,
        },
        {
          title: 'Loaded Date',
          dataIndex: 'pickupDate',
          key: 'pickupDate',
          width: 180,
        },
        {
          title: 'Delivered Date',
          dataIndex: 'deliveryDate',
          key: 'deliveryDate',
          width: 180,
        },
        {
          title: 'Job No.',
          dataIndex: 'jobNumber',
          key: 'jobNumber',
          width: 160,
        },
        {
          title: 'Vendor Code',
          dataIndex: 'vendorName',
          key: 'vendorName',
          width: 280,
        },
        {
          title: 'Truck Types',
          dataIndex: 'truckType',
          key: 'truckType',
          width: 150,
        },
        {
          title: 'License Plates',
          dataIndex: 'licensePlate',
          key: 'licensePlate',
          width: 120,
        },
        {
          title: 'Driver Names',
          dataIndex: 'driver',
          key: 'driver',
          width: 150,
        },
      ],
    },
    {
      title: 'Transport Cost Info.',
      align: 'left',
      style: {
        padding: '6px',
        alignItems: 'flex-end',
        backgroundColor: '#FDDF7C',
        margin: '-6px',
      },
      children: [
        {
          title: 'Transport',
          dataIndex: 'costPrice',
          key: 'costPrice',
          width: 100,
          align: 'right',
          style: {
            padding: '6px',
            alignItems: 'flex-end',
            backgroundColor: '#FFEEB6',
            margin: '-6px',
          },
        },
        {
          title: 'Total',
          dataIndex: 'totalCostPrice',
          key: 'totalCostPrice',
          width: 100,
          align: 'right',
          style: {
            padding: '6px',
            alignItems: 'flex-end',
            backgroundColor: '#FFEEB6',
            margin: '-6px',
          },
        },
      ],
    },
    {
      title: 'Service Cost Info.',
      align: 'left',
      style: {
        padding: '6px',
        alignItems: 'flex-end',
        backgroundColor: '#FDDF7C',
        margin: '-6px',
      },
      children: [
        {
          title: 'จำนวนชั้นที่ยก',
          dataIndex: 'costCarryHight',
          key: 'costCarryHight',
          width: 100,
          align: 'right',
          style: {
            padding: '6px',
            alignItems: 'flex-end',
            backgroundColor: '#FFEEB6',
            margin: '-6px',
          },
        },
        {
          title: 'ค่ายก',
          dataIndex: 'costCarry',
          key: 'costCarry',
          width: 100,
          align: 'right',
          style: {
            padding: '6px',
            alignItems: 'flex-end',
            backgroundColor: '#FFEEB6',
            margin: '-6px',
          },
        },
        {
          title: 'OT',
          dataIndex: 'costOT',
          key: 'costOT',
          width: 100,
          align: 'right',
          style: {
            padding: '6px',
            alignItems: 'flex-end',
            backgroundColor: '#FFEEB6',
            margin: '-6px',
          },
        },
        {
          title: 'Return',
          dataIndex: 'returnFee',
          key: 'returnFee',
          width: 130,
          align: 'right',
          style: {
            padding: '6px',
            alignItems: 'flex-end',
            backgroundColor: '#FFEEB6',
            margin: '-6px',
          },
        },
        {
          title: 'DROP',
          dataIndex: 'drop',
          key: 'drop',
          width: 130,
          align: 'right',
          style: {
            padding: '6px',
            alignItems: 'flex-end',
            backgroundColor: '#FFEEB6',
            margin: '-6px',
          },
        },
        {
          title: 'Unpack',
          dataIndex: 'costUnpack',
          key: 'costUnpack',
          width: 100,
          align: 'right',
          style: {
            padding: '6px',
            alignItems: 'flex-end',
            backgroundColor: '#FFEEB6',
            margin: '-6px',
          },
        },
        {
          title: 'Label',
          dataIndex: 'costLabel',
          key: 'costLabel',
          width: 100,
          align: 'right',
          style: {
            padding: '6px',
            alignItems: 'flex-end',
            backgroundColor: '#FFEEB6',
            margin: '-6px',
          },
        },
        {
          title: 'Other',
          dataIndex: 'costOther',
          key: 'costOther',
          width: 100,
          align: 'right',
          style: {
            padding: '6px',
            alignItems: 'flex-end',
            backgroundColor: '#FFEEB6',
            margin: '-6px',
          },
        },
        {
          title: 'Total',
          dataIndex: 'costTotal',
          key: 'costTotal',
          width: 100,
          align: 'right',
          style: {
            padding: '6px',
            alignItems: 'flex-end',
            backgroundColor: '#FFEEB6',
            margin: '-6px',
          },
        },
      ],
    },
  ];

  const sumPriceAll = () => {
    setTotalCostPrice(
      priceCost.map((priceObj) => {
        return (
          (Number(priceObj.carry) || 0) +
          (Number(priceObj.ot) || 0) +
          (Number(priceObj.returnFee) || 0) +
          (Number(priceObj.drop) || 0) +
          (Number(priceObj.unpack) || 0) +
          (Number(priceObj.label) || 0) +
          (Number(priceObj.fuel) || 0) +
          (Number(priceObj.wh) || 0) +
          (Number(priceObj.other) || 0)
        );
      }),
    );
  };

  const sumPrice = (priceObj) => {
    return (
      (Number(priceObj.carry) || 0) +
      (Number(priceObj.ot) || 0) +
      (Number(priceObj.returnFee) || 0) +
      (Number(priceObj.drop) || 0) +
      (Number(priceObj.unpack) || 0) +
      (Number(priceObj.label) || 0) +
      (Number(priceObj.fuel) || 0) +
      (Number(priceObj.wh) || 0) +
      (Number(priceObj.other) || 0)
    );
  };

  const dataTableService = useMemo(
    () =>
      order.map((item, index) => ({
        key: `costing-table-${item._id || uuidv4()}`,
        orderNo: item.orderNo,
        pickupName: item.pickupName,
        pickupProvince: item.pickupProvince,
        consigneeName: item.consigneeName,
        type: item.type,
        pricingType: item.pricingType,
        billingMonth: item.billingMonth,
        deliveryProvince: item.deliveryProvince,
        deliveryZone: item.deliveryZone,
        cbm: (
          <div
            style={{
              margin: '-6px',
              padding: '6px',
            }}
          >
            <StyledFormItem>
              <Controller
                control={control}
                name={`priceCost[${index}].cbm`}
                render={({ onChange, onBlur }) => (
                  <InputNumberFormat
                    value={
                      priceCost && priceCost[index] ? priceCost[index].cbm : item.cbm || 0
                    }
                    onValueChange={(valueChange) => {
                      onChange(valueChange.floatValue);
                      trigger([`priceCost[${index}].cbm`]);
                      onChangePriceCost(index, 'cbm', valueChange.floatValue);
                    }}
                    decimalScale={3}
                    placeholder="0.000"
                    onBlur={() => {
                      onBlur();
                      setpriceCostOnBlur(true);
                    }}
                  />
                )}
              />
            </StyledFormItem>
          </div>
        ),
        itemName: item.itemName,
        quantity: item.quantity,
        liftQuantity: item.liftQuantity,
        unpackQuantity: item.unpackQuantity,
        otherServiceQuantity: item.otherServiceQuantity || 0,
        rtQuantity: item.rtQuantity,
        rtName: item.rtName,
        tripNo,
        pickupDate: formatDateTime(item.pickupDate),
        deliveryDate: formatDateTime(item.deliveryDate),
        jobNumber,
        vendorName: vendor.vendorName,
        truckType,
        licensePlate,
        driver,
        costPrice: (
          <div
            style={{
              backgroundColor: '#FFF8E1',
              margin: '-6px',
              padding: '12px 6px',
              height: '45px',
            }}
          >
            {/* eslint-disable-next-line no-nested-ternary */}
            {item.pricingType === 'CBM Rate'
              ? formatCurrency(item.priceCost.transport)
              : index === 0
              ? formatCurrency(Number(cost), '0.00')
              : '-'}
          </div>
        ),
        totalCostPrice: (
          <div
            style={{
              backgroundColor: '#FFF8E1',
              margin: '-6px',
              padding: '12px 6px',
              height: '45px',
            }}
          >
            {index === 0 ? formatCurrency(Number(grandTotal.cost), '0.00') : '0.00'}
          </div>
        ),
        costCarryHight: (
          <div
            style={{
              backgroundColor: '#FFF8E1',
              margin: '-6px',
              padding: '6px',
            }}
          >
            <StyledFormItem>
              <Controller
                control={control}
                name={`priceCost[${index}].carryHight`}
                render={({ onChange, onBlur }) => (
                  <InputNumberFormat
                    value={
                      priceCost && priceCost[index]
                        ? priceCost[index].carryHight
                        : item.carryHight || '0'
                    }
                    onValueChange={(valueChange) => {
                      onChange(valueChange.floatValue);
                      trigger([`priceCost[${index}].carryHight`]);
                      onChangePriceCost(index, 'carryHight', valueChange.floatValue);
                    }}
                    decimalScale={0}
                    placeholder="0"
                    onBlur={() => {
                      onBlur();
                      setpriceCostOnBlur(true);
                    }}
                  />
                )}
              />
            </StyledFormItem>
          </div>
        ),
        costCarry: (
          <div
            style={{
              backgroundColor: '#FFF8E1',
              margin: '-6px',
              padding: '6px',
            }}
          >
            <StyledFormItem>
              <Controller
                control={control}
                name={`priceCost[${index}].carry`}
                defaultValue={item.priceCost?.carry || '0'}
                render={({ onChange, value, onBlur }) => (
                  <InputNumberFormat
                    value={priceCost && priceCost[index] ? priceCost[index].carry : value}
                    onValueChange={(valueChange) => {
                      onChange(valueChange.floatValue);
                      trigger([`priceCost[${index}].carry`]);
                      onChangePriceCost(index, 'carry', valueChange.floatValue);
                    }}
                    decimalScale={0}
                    placeholder="0"
                    onBlur={() => {
                      onBlur();
                      setpriceCostOnBlur(true);
                    }}
                  />
                )}
              />
            </StyledFormItem>
          </div>
        ),
        costOT: (
          <div
            style={{
              backgroundColor: '#FFF8E1',
              margin: '-6px',
              padding: '6px',
            }}
          >
            <StyledFormItem>
              <Controller
                control={control}
                name={`priceCost[${index}].ot`}
                defaultValue={item.priceCost?.ot || '0'}
                render={({ onChange, value, onBlur }) => (
                  <InputNumberFormat
                    value={priceCost && priceCost[index] ? priceCost[index].ot : value}
                    onValueChange={(valueChange) => {
                      onChange(valueChange.floatValue);
                      trigger([`priceCost[${index}].ot`]);
                      onChangePriceCost(index, 'ot', valueChange.floatValue);
                    }}
                    decimalScale={0}
                    placeholder="0"
                    onBlur={() => {
                      onBlur();
                      setpriceCostOnBlur(true);
                    }}
                  />
                )}
              />
            </StyledFormItem>
          </div>
        ),
        costOvernightFee: (
          <div
            style={{
              backgroundColor: '#FFF8E1',
              margin: '-6px',
              padding: '6px',
            }}
          >
            <StyledFormItem>
              <Controller
                control={control}
                name={`priceCost[${index}].overnightFee`}
                defaultValue={item.priceCost?.overnightFee || '0'}
                render={({ onChange, value, onBlur }) => (
                  <InputNumberFormat
                    value={priceCost && priceCost[index] ? priceCost[index].overnightFee : value}
                    onValueChange={(valueChange) => {
                      onChange(valueChange.floatValue);
                      trigger([`priceCost[${index}].overnightFee`]);
                      onChangePriceCost(index, 'overnightFee', valueChange.floatValue);
                    }}
                    decimalScale={0}
                    placeholder="0"
                    onBlur={() => {
                      onBlur();
                      setpriceCostOnBlur(true);
                    }}
                  />
                )}
              />
            </StyledFormItem>
          </div>
        ),
        returnFee: (
          <div
            style={{
              backgroundColor: '#FFF8E1',
              margin: '-6px',
              padding: '6px',
            }}
          >
            <StyledFormItem>
              <Controller
                control={control}
                name={`priceCost[${index}].returnFee`}
                defaultValue={item.priceCost?.returnFee || '0'}
                render={({ onChange, value, onBlur }) => (
                  <InputNumberFormat
                    value={priceCost && priceCost[index] ? priceCost[index].returnFee : value}
                    onValueChange={(valueChange) => {
                      onChange(valueChange.floatValue);
                      trigger([`priceCost[${index}].returnFee`]);
                      onChangePriceCost(index, 'returnFee', valueChange.floatValue);
                    }}
                    decimalScale={0}
                    placeholder="0"
                    onBlur={() => {
                      onBlur();
                      setpriceCostOnBlur(true);
                    }}
                  />
                )}
              />
            </StyledFormItem>
          </div>
        ),
        drop: (
          <div
            style={{
              backgroundColor: '#FFF8E1',
              margin: '-6px',
              padding: '6px',
            }}
          >
            <StyledFormItem>
              <Controller
                control={control}
                name={`priceCost[${index}].drop`}
                defaultValue={item.priceCost?.drop || '0'}
                render={({ onChange, value, onBlur }) => (
                  <InputNumberFormat
                    value={priceCost && priceCost[index] ? priceCost[index].drop : value}
                    onValueChange={(valueChange) => {
                      onChange(valueChange.floatValue);
                      trigger([`priceCost[${index}].drop`]);
                      onChangePriceCost(index, 'drop', valueChange.floatValue);
                    }}
                    decimalScale={0}
                    placeholder="0"
                    onBlur={() => {
                      onBlur();
                      setpriceCostOnBlur(true);
                    }}
                  />
                )}
              />
            </StyledFormItem>
          </div>
        ),
        costUnpack: (
          <div
            style={{
              backgroundColor: '#FFF8E1',
              margin: '-6px',
              padding: '6px',
            }}
          >
            <StyledFormItem>
              <Controller
                control={control}
                name={`priceCost[${index}].unpack`}
                defaultValue={item.priceCost?.unpack || '0'}
                render={({ onChange, value, onBlur }) => (
                  <InputNumberFormat
                    value={priceCost && priceCost[index] ? priceCost[index].unpack : value}
                    onValueChange={(valueChange) => {
                      onChange(valueChange.floatValue);
                      trigger([`priceCost[${index}].unpack`]);
                      onChangePriceCost(index, 'unpack', valueChange.floatValue);
                    }}
                    decimalScale={0}
                    placeholder="0"
                    onBlur={() => {
                      onBlur();
                      setpriceCostOnBlur(true);
                    }}
                  />
                )}
              />
            </StyledFormItem>
          </div>
        ),
        costLabel: (
          <div
            style={{
              backgroundColor: '#FFF8E1',
              margin: '-6px',
              padding: '6px',
            }}
          >
            <StyledFormItem>
              <Controller
                control={control}
                name={`priceCost[${index}].label`}
                defaultValue={item.priceCost?.label || '0'}
                render={({ onChange, value, onBlur }) => (
                  <InputNumberFormat
                    value={priceCost && priceCost[index] ? priceCost[index].label : value}
                    onValueChange={(valueChange) => {
                      onChange(valueChange.floatValue);
                      trigger([`priceCost[${index}].label`]);
                      onChangePriceCost(index, 'label', valueChange.floatValue);
                    }}
                    decimalScale={0}
                    placeholder="0"
                    onBlur={() => {
                      onBlur();
                      setpriceCostOnBlur(true);
                    }}
                  />
                )}
              />
            </StyledFormItem>
          </div>
        ),
        costOther: (
          <div
            style={{
              backgroundColor: '#FFF8E1',
              margin: '-6px',
              padding: '6px',
            }}
          >
            <StyledFormItem>
              <Controller
                control={control}
                name={`priceCost[${index}].other`}
                defaultValue={item.priceCost?.other || '0'}
                render={({ onChange, value, onBlur }) => (
                  <InputNumberFormat
                    value={priceCost && priceCost[index] ? priceCost[index].other : value}
                    onValueChange={(valueChange) => {
                      onChange(valueChange.floatValue);
                      trigger([`priceCost[${index}].other`]);
                      onChangePriceCost(index, 'other', valueChange.floatValue);
                    }}
                    decimalScale={0}
                    placeholder="0"
                    onBlur={() => {
                      onBlur();
                      setpriceCostOnBlur(true);
                    }}
                  />
                )}
              />
            </StyledFormItem>
          </div>
        ),
        costTotal: (
          <div
            style={{
              backgroundColor: '#FFF8E1',
              margin: '-6px',
              padding: '12px 6px',
              height: '45px',
            }}
          >
            {formatCurrency(
              Number(totalCostPrice[index] || sumPrice(item.priceCost) || '0.00'),
              '0.00',
            )}
          </div>
        ),
        revenuePrice: (
          <div
            style={{
              backgroundColor: '#EDF9E9',
              margin: '-6px',
              padding: '13px 6px',
            }}
          >
            {index === 0 ? formatCurrency(Number(revenue), '-') : '-'}
          </div>
        ),
        revenueTotalPrice: (
          <div
            style={{
              backgroundColor: '#EDF9E9',
              margin: '-6px',
              padding: '13px 6px',
            }}
          >
            {index === 0 ? formatCurrency(Number(revenue), '-') : '-'}
          </div>
        ),
        revenueCarryHight: (
          <div
            style={{
              backgroundColor: '#EDF9E9',
              margin: '-6px',
              padding: '6px',
            }}
          >
            {formatCurrency(Number(item.carryHight || 0), '-')}
          </div>
        ),
        revenueCarry: (
          <div
            style={{
              backgroundColor: '#EDF9E9',
              margin: '-6px',
              padding: '6px',
            }}
          >
            {formatCurrency(Number(item.priceSale.carry || 0), '-')}
          </div>
        ),
        revenueOT: (
          <div
            style={{
              backgroundColor: '#EDF9E9',
              margin: '-6px',
              padding: '6px',
            }}
          >
            {formatCurrency(Number(item.priceSale.ot || 0), '-')}
          </div>
        ),
        revenueOvernightFee: (
          <div
            style={{
              backgroundColor: '#EDF9E9',
              margin: '-6px',
              padding: '6px',
            }}
          >
            {formatCurrency(Number(item.priceSale.overnightFee || 0), '-')}
          </div>
        ),
        revenueUnpack: (
          <div
            style={{
              backgroundColor: '#EDF9E9',
              margin: '-6px',
              padding: '6px',
            }}
          >
            {formatCurrency(Number(item.priceSale.unpack || 0), '-')}
          </div>
        ),
        revenueLabel: (
          <div
            style={{
              backgroundColor: '#EDF9E9',
              margin: '-6px',
              padding: '6px',
            }}
          >
            {formatCurrency(Number(item.priceSale.label || 0), '-')}
          </div>
        ),
        revenueFuel: (
          <div
            style={{
              backgroundColor: '#EDF9E9',
              margin: '-6px',
              padding: '6px',
            }}
          >
            {formatCurrency(Number(item.priceSale.fuel || 0), '-')}
          </div>
        ),
        revenueWH: (
          <div
            style={{
              backgroundColor: '#EDF9E9',
              margin: '-6px',
              padding: '6px',
            }}
          >
            {formatCurrency(Number(item.priceSale.wh || 0), '-')}
          </div>
        ),
        revenueOther: (
          <div
            style={{
              backgroundColor: '#EDF9E9',
              margin: '-6px',
              padding: '6px',
            }}
          >
            {formatCurrency(Number(item.priceSale.other || 0), '0.00')}
          </div>
        ),
        revenueTotal: (
          <div
            style={{
              backgroundColor: '#EDF9E9',
              margin: '-6px',
              padding: '6px',
            }}
          >
            {formatCurrency(Number(sumPrice(item.priceSale) || 0), '-')}
          </div>
        ),
      })),
    [totalCostPrice, priceCost],
  );

  const onSubmitCostTable = async () => {
    setIsLoading(true);
    try {
      const objUpdate = order.map((item, index) => {
        return {
          ...item,
          cbm:
            priceCost && priceCost[index] && priceCost[index].cbm !== undefined
              ? priceCost[index].cbm
              : item.cbm || 0,
          carryHight:
            priceCost && priceCost[index] ? priceCost[index].carryHight : item.carryHight || 0,
          priceCost: {
            carry:
              priceCost && priceCost[index] ? priceCost[index].carry : item.priceCost?.carry || 0,
            ot: priceCost && priceCost[index] ? priceCost[index].ot : item.priceCost?.ot || 0,
            returnFee:
              priceCost && priceCost[index]
                ? priceCost[index].returnFee
                : item.priceCost?.returnFee || 0,
            drop: priceCost && priceCost[index] ? priceCost[index].drop : item.priceCost?.drop || 0,
            unpack:
              priceCost && priceCost[index] ? priceCost[index].unpack : item.priceCost?.unpack || 0,
            label:
              priceCost && priceCost[index] ? priceCost[index].label : item.priceCost?.label || 0,
            other:
              priceCost && priceCost[index] ? priceCost[index].other : item.priceCost?.other || 0,
            transport:
              priceCost && priceCost[index]
                ? priceCost[index].transport
                : item.priceCost?.transport || 0,
          },
        };
      });
      await axiosErp(token).post(`update-costing-trip-turboo`, {
        filter: { _id },
        update: { order: objUpdate },
      });

      await queryClient.refetchQueries(['costing-job-detail', _id]);
      setIsLoading(false);
    } catch (e) {
      message.error(e.message || 'เกิดข้อผิดพลาดในการแก้ไขรายได้');
      console.error('ERROR TO LOAD COSTING DETAIL: ', e);
    } finally {
      message.success('ยืนยันการแก้ไขรายได้เรียบร้อยแล้ว');
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (isLoading && priceCost.length === 0) {
      setpriceCost(
        order.map((item, index) => {
          const existingpriceCost =
            priceCost && priceCost[index] ? priceCost[index] : item.priceCost || {};
          return {
            _id: item._id,
            carryHight: item.carryHight,
            carry: existingpriceCost.carry || '0',
            ot: existingpriceCost.ot || '0',
            returnFee: existingpriceCost.returnFee || '0',
            drop: existingpriceCost.drop || '0',
            unpack: existingpriceCost.unpack || '0',
            label: existingpriceCost.label || '0',
            other: existingpriceCost.other || '0',
            transport: existingpriceCost.transport || '0',
            cbm: priceCost[index]?.cbm !== undefined ? priceCost[index].cbm : item.cbm || 0,
          };
        }),
      );
      setIsLoading(false);
    } else if (priceCostOnBlur) {
      sumPriceAll();
      console.log('PRICE COST UPDATED: ', priceCost);
      setpriceCostOnBlur(false);
    }
  }, [order, priceCost, priceCostOnBlur]);

  return (
    <>
      <StyledContainerButton style={{ alignContent: 'flex-end' }}>
        <StyledButton
          disabled={isLoading || !priceCostOnChange}
          icon={<SaveOutlined />}
          color="green"
          onClick={() => onSubmitCostTable()}
        >
          บันทึกค่าใช้จ่าย
        </StyledButton>
      </StyledContainerButton>
      <TableCosting
        bordered
        className="table-1"
        pagination={false}
        columns={columnsTableService}
        dataSource={dataTableService}
      />
    </>
  );
};

export default RevenueTable;
